import { render } from "./SharingPage.vue?vue&type=template&id=0a2c6391&scoped=true"
import script from "./SharingPage.vue?vue&type=script&lang=js"
export * from "./SharingPage.vue?vue&type=script&lang=js"

import "./SharingPage.vue?vue&type=style&index=0&id=0a2c6391&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2c6391"]])

export default __exports__